import { render, staticRenderFns } from "./blog-disclaimer.html?vue&type=template&id=a3ad30ac&scoped=true&external"
import script from "./blog-disclaimer.js?vue&type=script&lang=js&external"
export * from "./blog-disclaimer.js?vue&type=script&lang=js&external"
import style0 from "./blog-disclaimer.scss?vue&type=style&index=0&id=a3ad30ac&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ad30ac",
  null
  
)

export default component.exports